import _omit from 'lodash/omit'

import {
  ADMIN_GET_USER_DETAILS,
  ADMIN_GET_USER_DETAILS_SUCCESS,
  ADMIN_UPDATE_USER_ACCOUNT_SUCCESS
} from './admin'
import { getCSRF } from './global'

export const initialState = {
  isAuthenticated: false,
  hasRemoteSessions: false,
  emailChangeRequired: false,
  isAdmin: false,
  details: null,
  address: null,
  loading: false,
  error: null
}

export const LOGIN_REQUEST = 'LOGIN_REQUEST'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_ERROR = 'LOGIN_ERROR'

export const REGISTER_REQUEST = 'REGISTER_REQUEST'
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS'
export const REGISTER_ERROR = 'REGISTER_ERROR'

export const USER_ACCOUNT_REQUEST = 'USER_ACCOUNT_REQUEST'
export const USER_ACCOUNT_SUCCESS = 'USER_ACCOUNT_SUCCESS'
export const USER_ACCOUNT_ERROR = 'USER_ACCOUNT_ERROR'

export const USER_ACCOUNT_UPDATE_REQUEST = 'USER_ACCOUNT_UPDATE_REQUEST'
export const USER_ACCOUNT_UPDATE_SUCCESS = 'USER_ACCOUNT_UPDATE_SUCCESS'
export const USER_ACCOUNT_UPDATE_ERROR = 'USER_ACCOUNT_UPDATE_ERROR'

export const LOGOUT_REQUEST = 'LOGOUT_REQUEST'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
export const LOGOUT_ERROR = 'LOGOUT_ERROR'

export const REMOTE_SESSION_TERMINATE_REQUEST = 'REMOTE_SESSION_TERMINATE_REQUEST'
export const REMOTE_SESSION_TERMINATE_SUCCESS = 'REMOTE_SESSION_TERMINATE_SUCCESS'
export const REMOTE_SESSION_TERMINATE_ERROR = 'REMOTE_SESSION_TERMINATE_ERROR'

export const USER_PASSWORD_RESET_REQUEST = 'USER_PASSWORD_RESET_REQUEST'
export const USER_PASSWORD_RESET_SUCCESS = 'USER_PASSWORD_RESET_SUCCESS'
export const USER_PASSWORD_RESET_ERROR = 'USER_PASSWORD_RESET_ERROR'


export const logIn = credentials => async (dispatch, getState, { httpRequest }) => {
  dispatch({ type: LOGIN_REQUEST })
  try {
    const csrf = await dispatch(getCSRF())
    const res = await httpRequest.post('/login', { ...credentials }, {
      headers: {
        'x-csrf-token': csrf.token
      }
    })
    dispatch({
      type: LOGIN_SUCCESS,
      user: res.data
     })
     return Promise.resolve(res.data)
  } catch (err) {
    dispatch({
      type: LOGIN_ERROR,
      loginError: null
    })

    return Promise.reject(err)
  }
}

export const logout = () => (dispatch, getState, { httpRequest }) => {
  dispatch({ type: LOGOUT_REQUEST })
  return httpRequest.get('/logout')
    .then(res => {
      dispatch({
        type: LOGOUT_SUCCESS,
        user: res.data
       })
       return Promise.resolve(res.data)
    })
    .catch(err => {
      dispatch({
        type: LOGOUT_ERROR,
        loginError: null
      })

      return Promise.reject(err)
    })
}

export const register = credentials => async (dispatch, getState, { httpRequest }) => {
  dispatch({ type: REGISTER_REQUEST })
  try {
    const csrf = await dispatch(getCSRF())
    const res = await httpRequest.post('/register', { ...credentials }, {
      headers: {
        'x-csrf-token': csrf.token
      }
    })
    dispatch({
      type: REGISTER_SUCCESS,
      user: res.data
     })
     return Promise.resolve(res.data)
  } catch (err) {
    dispatch({
      type: REGISTER_ERROR
    })
    return Promise.reject(err)
  }
}

export const logOut = () => (dispatch, getState, { httpRequest }) => {
  dispatch({ type: LOGOUT_REQUEST })
  return httpRequest.get('/logout')
    .then(() => {
      dispatch({
        type: LOGOUT_SUCCESS
       })
    })
    .catch(err=> {
      console.error(err)
      dispatch({
        type: LOGOUT_ERROR
      })
    })
}

export const terminateRemoteSessions = () => async (dispatch, getState, { httpRequest }) => {
  dispatch({ type: REMOTE_SESSION_TERMINATE_REQUEST })
  try {
    const csrf = await dispatch(getCSRF())
    const res = await httpRequest.post('/terminate-remote-sessions', {}, {
      headers: {
        'x-csrf-token': csrf.token
      }
    })
    dispatch({
      type: REMOTE_SESSION_TERMINATE_SUCCESS
     })
     return Promise.resolve(res.data)
  } catch (err) {
    console.error(err)
    dispatch({
      type: REMOTE_SESSION_TERMINATE_ERROR
    })
    return Promise.reject(err)
  }
}

export const getUserData = userId => (dispatch, getState, { httpRequest }) => {
  const currentUser = getState().user.details.id

  if (userId && userId !== currentUser) {
    dispatch({ type: ADMIN_GET_USER_DETAILS })
  } else {
    dispatch({ type: USER_ACCOUNT_REQUEST })
  }

  return httpRequest.get(`/account/${userId || currentUser}`)
    .then(res => {
      if (userId && userId !== currentUser) {
        dispatch({
          type: ADMIN_GET_USER_DETAILS_SUCCESS,
          user: res.data
         })
      } else {
        dispatch({
          type: USER_ACCOUNT_SUCCESS,
          user: res.data
         })
      }
      return Promise.resolve(res.data)
    })
    .catch(err => {
      dispatch({
        type: USER_ACCOUNT_ERROR
      })
      console.error(err)
    })
}

export const accountUpdate = data => async (dispatch, getState, { httpRequest }) => {
  const currentUserId = getState().user.details.id

  dispatch({ type: USER_ACCOUNT_UPDATE_REQUEST })
  try {
    const csrf = await dispatch(getCSRF())
    const res = await httpRequest.post(`/account/${data.user.id}`, data, {
      headers: {
        'x-csrf-token': csrf.token
      }
    })
    if (currentUserId === res.data.id) {
      dispatch({
        type: USER_ACCOUNT_UPDATE_SUCCESS,
        user: res.data
      })
    } else {
      dispatch({
        type: ADMIN_UPDATE_USER_ACCOUNT_SUCCESS,
        user: res.data
      })
    }
    return Promise.resolve(res.data)

  } catch (err) {
    dispatch({
      type: USER_ACCOUNT_UPDATE_ERROR
    })
    console.error(err)
    return Promise.reject(err)
  }
}

export const sendForgotPassword = data => async (dispatch, getState, { httpRequest }) => {
  dispatch({ type: USER_PASSWORD_RESET_REQUEST })
  try {
    const csrf = await dispatch(getCSRF())
    const res = await httpRequest.post(`/forgot`, data, {
      headers: {
        'x-csrf-token': csrf.token
      }
    })

    dispatch({
      type: USER_PASSWORD_RESET_SUCCESS,
     })
    return Promise.resolve(res.data)

  } catch (err) {
    dispatch({
      type: USER_PASSWORD_RESET_ERROR,
      error: err.response.data
    })
    return Promise.reject(err)
  }
}

export const resetPassword = data => async (dispatch, getState, { httpRequest }) => {
  try {
    const csrf = await dispatch(getCSRF())
    const res = await httpRequest.post('/reset', data, {
      headers: {
        'x-csrf-token': csrf.token
      }
    })

    dispatch({
      type: USER_PASSWORD_RESET_SUCCESS,
     })
    return Promise.resolve(res.data)

  } catch (err) {
    dispatch({
      type: USER_PASSWORD_RESET_ERROR,
      error: err.response.data
    })
    return Promise.reject(err)
  }
}

export const getForgotPasswordSettings = token => (dispatch, getState, { httpRequest }) => {
  return httpRequest.get(`/forgot-settings`, { params: { token } })
    .then(res => {
       return Promise.resolve(res.data)
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

const ACTION_HANDLERS = {
  [LOGIN_REQUEST]: state => ({
    ...state,
    loading: true
  }),
  [LOGIN_SUCCESS]: (state, { user }) => ({
    ...state,
    details: {
      ..._omit(user, ['address'])
    },
    address: {
      ...user.address
    },
    isAuthenticated: true,
    isAdmin: user.is_admin,
    hasRemoteSessions: user.hasRemoteSessions,
    loading: false
  }),
  [LOGIN_ERROR]: (state, { loginError }) => ({
    ...state,
    loginError,
    loading: false
  }),
  [REGISTER_SUCCESS]: (state, { user }) => ({
    ...state,
    details: {
      ..._omit(user, ['address'])
    },
    address: {
      ...user.address
    },
    // Registering doesn't sign the user in yet — they still need to verify their
    // email and log in. Saying otherwise here logs them straight back out and
    // empties their cart.
    isAuthenticated: false,
    isAdmin: user.is_admin,
    loading: false
  }),
  [USER_ACCOUNT_REQUEST]: state => ({
    ...state,
    user: null,
    address: null,
    loading: true
  }),
  [USER_ACCOUNT_SUCCESS]: (state, { user }) => ({
    ...state,
    details: {
      ..._omit(user, ['address', 'login_history'])
    },
    address: {
      ...user.address
    },
    isAdmin: user.is_admin,
    loading: false
  }),
  [USER_ACCOUNT_UPDATE_REQUEST]: state => ({
    ...state,
    loading: true
  }),
  [USER_ACCOUNT_UPDATE_SUCCESS]: (state, { user }) => ({
    ...state,
    details: {
      ..._omit(user, ['address', 'login_history'])
    },
    address: {
      ...user.address
    },
    loading: false
  }),
  [USER_ACCOUNT_UPDATE_ERROR]: state => ({
    ...state,
    loading: false
  }),
  [USER_ACCOUNT_UPDATE_REQUEST]: state => ({
    ...state,
    loading: true
  }),
  [LOGOUT_SUCCESS]: () => ({
    ...initialState
  }),
  [REMOTE_SESSION_TERMINATE_SUCCESS]: state => ({
    ...state,
    hasRemoteSessions: false
  }),
  [USER_PASSWORD_RESET_REQUEST]: state => ({
    ...state,
    loading: true
  }),
  [USER_PASSWORD_RESET_SUCCESS]: state => ({
    ...state,
    loading: false
  }),
  [USER_PASSWORD_RESET_ERROR]: (state, { error }) => ({
    ...state,
    loading: false,
    error
  })
}

export default function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./reducers/user.js